import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { MRR_TREND } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Total MRR by month — the headline recurring-revenue level, climbing net of all
 * five movements. The app's positive green, landing on the example's $25,000.
 */
const MrrChart = () => (
  <MetricChartFrame
    caption="Total MRR climbs from $20,000 to $25,000 over six months — the net result of new and expansion revenue outpacing contraction and churn."
    chartType="Line"
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={MRR_TREND} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={52} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "MRR"]}
      />
      <Bar dataKey="value" fill={CHART_POSITIVE} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default MrrChart;
